import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import type { MediaItemValue } from '@fulcrumapp/fulcrum-core';
import { useApp } from '../../../hooks/use-app';

const Thumbnail = styled(Box)({
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  position: 'relative',
  width: 80,
  height: 80,
  marginTop: 20,
  display: 'inline-block',
  marginRight: 20,
  borderRadius: 3,
  cursor: 'pointer',

  ':last-child': {
    marginRight: 0,
  },
});

type Props = {
  item: MediaItemValue;
  styles: React.CSSProperties;
  handleClick: (e: React.MouseEvent<HTMLDivElement>) => void;
  children?: React.ReactNode;
  'data-testid'?: string;
};

const MediaThumbnail = ({
  item, styles, handleClick, children, 'data-testid': dataTestId = 'media-thumbnail',
}: Props) => {
  const app = useApp();
  const [imageURL, setImageURL] = useState('');

  useEffect(() => {
    setImageURL(app.dataSource.source.getThumbnailURL(item));
  }, [app, item]);

  const allStyles = {
    backgroundImage: `url(${imageURL})`,
    ...styles,
  };

  return (
    <Thumbnail
      sx={allStyles}
      onClick={handleClick}
      data-testid={dataTestId}
    >
      {children}
    </Thumbnail>
  );
};

export default MediaThumbnail;
